import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Clock } from 'lucide-react';
export function PricingSection() {
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="comprar" className="py-16 px-4 bg-brand-light relative" data-id="element-70">
      <div className="max-w-2xl mx-auto" data-id="element-71">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="bg-white rounded-3xl shadow-2xl border-2 border-brand-blue overflow-hidden" data-id="element-72">
          <div className="bg-brand-blue text-white text-center py-3 font-bold tracking-wider uppercase text-sm" data-id="element-73">
            Oferta Especial Limitada
          </div>

          <div className="p-6 md:p-10 text-center" data-id="element-74">
            <h2 className="text-3xl font-heading font-black text-brand-dark mb-2" data-id="element-75">
              Empieza hoy
            </h2>
            <p className="text-gray-600 mb-6 text-sm max-w-md mx-auto" data-id="element-76">
              Accede ahora a Kit Inmobiliario PRO y transforma la forma en que
              gestionas tus clientes inmobiliarios.
            </p>

            <div className="mb-6" data-id="element-77">
              <p className="text-gray-400 text-lg line-through font-semibold" data-id="element-78">
                $49.990
              </p>
              <div className="flex justify-center items-start gap-1" data-id="element-79">
                <span className="text-2xl font-bold text-brand-dark mt-1" data-id="element-80">
                  $
                </span>
                <span className="text-6xl font-heading font-black text-brand-dark" data-id="element-81">
                  19.990
                </span>
                <span className="text-lg font-bold text-gray-500 mt-6" data-id="element-82">
                  ARS
                </span>
              </div>
              <p className="text-brand-green font-bold mt-1 flex items-center justify-center gap-1.5 text-sm" data-id="element-83">
                <Clock className="w-4 h-4" data-id="element-84" />
                Precio especial + Bonos incluidos hoy
              </p>
            </div>

            <CTAButton text="COMPRAR AHORA" href="https://checkout.hacelosimple.shop/cart/48658908545267:1" isFinal={true} className="w-full text-xl py-4" data-id="element-85" />

            <div className="mt-4 flex items-center justify-center gap-2 text-xs text-gray-500" data-id="element-86">
              <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-87" />
              <span data-id="element-88">Pago 100% seguro y acceso inmediato</span>
            </div>
          </div>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="text-center mt-10" data-id="element-89">
          <p className="text-gray-700 mb-2" data-id="element-90">
            Organiza tus leads. Haz seguimiento como un profesional. Y empieza a
            cerrar más ventas.
          </p>
          <p className="text-xl font-bold text-brand-dark" data-id="element-91">
            Tu próximo cierre puede depender de esto.
          </p>
        </motion.div>
      </div>
    </section>;
}